import type { HubNavIcons } from '@/components/Hub/hubSectionTypes';

import challengesDark from '@/assets/hub/challenges_icon_dark.svg';
import challengesDarkSelected from '@/assets/hub/challenges_icon_dark_selected.svg';
import challengesLight from '@/assets/hub/challenges_icon_light.svg';
import challengesLightSelected from '@/assets/hub/challenges_icon_light_selected.svg';
import lessonsDark from '@/assets/hub/lessons_icon_dark.svg';
import lessonsDarkSelected from '@/assets/hub/lessons_icon_dark_selected.svg';
import lessonsLight from '@/assets/hub/lessons_icon_light.svg';
import lessonsLightSelected from '@/assets/hub/lessons_icon_light_selected.svg';
import libraryDark from '@/assets/hub/library_icon_dark.svg';
import libraryDarkSelected from '@/assets/hub/library_icon_dark_selected.svg';
import libraryLight from '@/assets/hub/library_icon_light.svg';
import libraryLightSelected from '@/assets/hub/library_icon_light_selected.svg';
import simulationsDark from '@/assets/hub/simulations_icon_dark.svg';
import simulationsDarkSelected from '@/assets/hub/simulations_icon_dark_selected.svg';
import simulationsLight from '@/assets/hub/simulations_icon_light.svg';
import simulationsLightSelected from '@/assets/hub/simulations_icon_light_selected.svg';
import spotlightDark from '@/assets/hub/spotlight_icon_dark.svg';
import spotlightDarkSelected from '@/assets/hub/spotlight_icon_dark_selected.svg';
import spotlightLight from '@/assets/hub/spotlight_icon_light.svg';
import spotlightLightSelected from '@/assets/hub/spotlight_icon_light_selected.svg';
import storiesDark from '@/assets/hub/stories_icon_dark.svg';
import storiesDarkSelected from '@/assets/hub/stories_icon_dark_selected.svg';
import storiesLight from '@/assets/hub/stories_icon_light.svg';
import storiesLightSelected from '@/assets/hub/stories_icon_light_selected.svg';

export const spotlightNavIcons: HubNavIcons = {
    light: { idle: spotlightLight, selected: spotlightLightSelected },
    dark: { idle: spotlightDark, selected: spotlightDarkSelected },
};

export const storiesNavIcons: HubNavIcons = {
    light: { idle: storiesLight, selected: storiesLightSelected },
    dark: { idle: storiesDark, selected: storiesDarkSelected },
};

export const simulationsNavIcons: HubNavIcons = {
    light: { idle: simulationsLight, selected: simulationsLightSelected },
    dark: { idle: simulationsDark, selected: simulationsDarkSelected },
};

export const lessonsNavIcons: HubNavIcons = {
    light: { idle: lessonsLight, selected: lessonsLightSelected },
    dark: { idle: lessonsDark, selected: lessonsDarkSelected },
};

export const challengesNavIcons: HubNavIcons = {
    light: { idle: challengesLight, selected: challengesLightSelected },
    dark: { idle: challengesDark, selected: challengesDarkSelected },
};

export const libraryNavIcons: HubNavIcons = {
    light: { idle: libraryLight, selected: libraryLightSelected },
    dark: { idle: libraryDark, selected: libraryDarkSelected },
};
